module.exports = __webpack_public_path__ + "static/media/long-stay.a2556d3b.png";